import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=a85036ee&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=a85036ee&lang=less&scoped=true&"
import style1 from "./pay.vue?vue&type=style&index=1&id=a85036ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85036ee",
  null
  
)

export default component.exports